var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-map"},[(_vm.showFilters)?_c('MapFilter',{ref:"filter",attrs:{"categories":_vm.filters,"selected":_vm.activeFilter},on:{"update:selected":function($event){_vm.activeFilter=$event}}}):_vm._e(),_vm._v(" "),_c('div',{ref:"map",staticClass:"product-map__map"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }